<template>
    <div class="login d-flex justify-content-center align-items-center">
        <form v-on:keyup.enter="sendLogin" class="shadow">
            <div id="banner">
                <span><img alt="Vue logo" src="../assets/horloge.png" /></span>
                <span>Time <br> Tracker</span>
            </div>
            <div >
                <div>
                    <input type="text" id="login" placeholder="Nom d'utilisateur" v-model="login">
                </div>
            </div>
            <div >
                <div>
                    <input type="password"  id="password" placeholder="Mot de passe" v-model="password">
                </div>
            </div>
            <div class="error row" v-if="errors.length">
                <ul>
                    <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
                </ul>
            </div>
            <div v-if="!pending" class="btn row btn-outline-success" v-on:click="sendLogin">Connexion</div>
        </form>
    </div>
</template>

<script>
    import router from "../router/index.js";

    const axios = require('axios');
    const md5 = require('md5');

    export default {
        name: "Login",
        data() {
            return {
                login: '',
                password: '',
                pending: false,
                errors: [],
            }
        },

        methods: {
            sendLogin() {
              console.dir(this.$store)
                this.errors=[];
                if (!this.login) {
                    this.errors.push('Veuillez renseigner votre login');
                } else if (!this.password) {
                    this.errors.push('Veuillez renseigner votre mots de passe')
                } else {
                    this.pending = true;
                    const hashedPass = md5(this.password);
                    axios.get(this.$store.state.apiUrl + 'user/login', {
                            params: {
                                login: this.login,
                                password: hashedPass
                            }
                        })
                        .then(response => (this.checkResponse(response), this.pending = false))
                        .catch((e) => {
                            console.log(e);
                            this.$toasted.show("Erreur de connexion, veuillez essayer ultérieurement", {
                                position: 'bottom-center',
                                theme: 'outline'
                            }).goAway(3000);
                            this.pending = false
                        })
                }
            },
            checkResponse: function(data) {
                if (data.status == 200) { // HTTP.OK
                    localStorage.login = data.data.login;
                    localStorage.id = data.data.id;
                    localStorage.pass = data.data.password;
                    localStorage.teamId = data.data.teamId;
                    localStorage.name = data.data.name;
                    localStorage.email = data.data.email;
                    localStorage.role = data.data.role;
                    
                    this.$store.commit('setConnected', true);
                    this.$store.commit('setRole', data.data.role);
                    
                    router.push('/');
                } else {
                    this.errors.push('Mauvaise combinaison login/mots de passe');
                }
                this.pending = false;
            }
        }
    };
</script>

<style scoped>
    
    #banner {
        width: 100%;
        display: table;
    }
    
    #banner img{
        margin-bottom: 4%;
        height: 10em;
    }
    
    #banner span{
        font-weight: bold;
        font-size: 28px;
        text-align: left;
        height: 100%;
        line-height: 26px;
        vertical-align: middle;
        display: table-cell;
        padding: .35em;
    }

    .login{
        height: 100%;
    }
    
    form {
        margin: auto;
        text-align: center;
        display: inline-block;
        padding: 2em;
    }
    
    form input {
        border: 1px solid #ced4da;
        border-radius: .25rem;
        margin-bottom: 1.5em;
        padding: 4px;
    }
    
    form input, .btn{
        width: 90%;
    }

    .btn{
        margin-top: 1.8em;    
    }
    
    ul{
        list-style: none;
        padding-inline-start: 0px;
    }

    .error {
        display: block;
        color: red;
        text-align: center;
    }
</style>